import { render, staticRenderFns } from "./TooltipAddToCartBtn.vue?vue&type=template&id=2be33a0f&scoped=true&"
import script from "./TooltipAddToCartBtn.vue?vue&type=script&lang=js&"
export * from "./TooltipAddToCartBtn.vue?vue&type=script&lang=js&"
import style0 from "./TooltipAddToCartBtn.vue?vue&type=style&index=0&id=2be33a0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be33a0f",
  null
  
)

export default component.exports